var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c(
                "base-card",
                [
                  _c("v-card-title", [_vm._v("Registrar Clientes FE")]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "NombreCompania",
                                attrs: {
                                  label: "Cliente",
                                  "prepend-inner-icon": "mdi-account-tie",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.NombreCompania,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataClient,
                                      "NombreCompania",
                                      $$v
                                    )
                                  },
                                  expression: "dataClient.NombreCompania",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "Estado",
                                attrs: {
                                  items: _vm.typeEnvironment,
                                  "item-text": "textEnvironment",
                                  "item-value": "valueEnvironment",
                                  label: "Ambiente",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.Estado,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataClient, "Estado", $$v)
                                  },
                                  expression: "dataClient.Estado",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "RefProveedor",
                                attrs: {
                                  items: _vm.listTechnologyProvider,
                                  "item-text": "textEnvironment",
                                  "item-value": "valueEnvironment",
                                  label: "Proveedor tecnológico",
                                  "prepend-inner-icon": "mdi-file-chart",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.Proveedor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataClient, "Proveedor", $$v)
                                  },
                                  expression: "dataClient.Proveedor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "Url",
                                attrs: {
                                  label: "Url Proveedor tecnológico",
                                  "prepend-inner-icon": "mdi-account-network",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.Url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataClient, "Url", $$v)
                                  },
                                  expression: "dataClient.Url",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "can",
                                    rawName: "v-can",
                                    value: "Visualizar TokenEnterprise RC",
                                    expression:
                                      "'Visualizar TokenEnterprise RC'",
                                  },
                                ],
                                ref: "TokenEnterprise",
                                attrs: {
                                  label: "Token Enterprise",
                                  "prepend-inner-icon": "mdi-account-key",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  disabled: _vm.isPrividerEDN,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.TokenEnterprise,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataClient,
                                      "TokenEnterprise",
                                      $$v
                                    )
                                  },
                                  expression: "dataClient.TokenEnterprise",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "TokenPassword",
                                attrs: {
                                  label: "Token Password",
                                  "prepend-inner-icon": "mdi-key",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  disabled: _vm.isPrividerEDN,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.TokenPassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataClient,
                                      "TokenPassword",
                                      $$v
                                    )
                                  },
                                  expression: "dataClient.TokenPassword",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.isPrividerEDN
                        ? _c("v-divider", { staticClass: "mt-4" })
                        : _vm._e(),
                      _vm.isPrividerEDN
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12" } },
                            [
                              _c("additional-data-client", {
                                ref: "AdditionalDataClientForm",
                                on: {
                                  "update:grant_type": _vm.updateGrantType,
                                  "update:client_id": _vm.updateClientId,
                                  "update:client_secret":
                                    _vm.updateClientSecret,
                                  "update:scope": _vm.updateScope,
                                  "update:url_token": _vm.updateUrlToken,
                                  "update:validate_forms":
                                    _vm.updateValidateFormAddData,
                                  "update:emisor_client_Id": _vm.updateEmisor,
                                  "update:representation_graphic":
                                    _vm.updateRepresentation,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "NitCliente",
                                attrs: {
                                  label: "Nit",
                                  "prepend-inner-icon":
                                    "mdi-pencil-box-outline",
                                  type: "number",
                                  clearable: "",
                                  rules: _vm.nitFormRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.NitCliente,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataClient, "NitCliente", $$v)
                                  },
                                  expression: "dataClient.NitCliente",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "EmailFE",
                                attrs: {
                                  label: "Email envío FE no procesadas",
                                  "prepend-inner-icon": "mdi-email",
                                  clearable: "",
                                  rules: _vm.emailRules,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataClient.EmailFE,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataClient, "EmailFE", $$v)
                                  },
                                  expression: "dataClient.EmailFE",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "EmailDelivery",
                                attrs: {
                                  label: "Email delivery",
                                  "prepend-inner-icon": "mdi-email",
                                  clearable: "",
                                  rules: _vm.emailDeliveryRules,
                                },
                                model: {
                                  value: _vm.dataClient.EmailDelivery,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.dataClient,
                                      "EmailDelivery",
                                      $$v
                                    )
                                  },
                                  expression: "dataClient.EmailDelivery",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          !_vm.isPrividerEDN
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "4" } },
                                [
                                  _c("v-select", {
                                    ref: "graphicalRepresentation",
                                    attrs: {
                                      items: _vm.representationOptions,
                                      "item-text": "textRepresentation",
                                      "item-value": "valueRepresentation",
                                      label: "Representación gráfica",
                                      "prepend-inner-icon": "mdi-image",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.graphicalRepresentation,
                                      callback: function ($$v) {
                                        _vm.graphicalRepresentation = $$v
                                      },
                                      expression: "graphicalRepresentation",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _vm.isPlus
                                ? _c("v-text-field", {
                                    ref: "valueTemplate",
                                    attrs: {
                                      label: "Codigo Plantilla",
                                      "prepend-inner-icon":
                                        "mdi mdi-image-auto-adjust",
                                      clearable: "",
                                      rules: _vm.ruleTemplate,
                                      "error-messages": _vm.errorMessages,
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.valueTemplate,
                                      callback: function ($$v) {
                                        _vm.valueTemplate = $$v
                                      },
                                      expression: "valueTemplate",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "tx-end",
                              attrs: {
                                cols: "12",
                                sm: !_vm.isPrividerEDN ? 4 : 12,
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.validateClient },
                                },
                                [_vm._v(" Registrar ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "GRAY" },
                                  on: { click: _vm.limpiarFormulario },
                                },
                                [_vm._v(" Limpiar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.successAlert,
                              expression: "successAlert",
                            },
                          ],
                          attrs: { type: _vm.alertType, text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgAlert) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }